import type { RouteParams } from "vue-router";

import { Schulform } from "@core/asd/types/schule/Schulform";
import { BenutzerKompetenz } from "@core/core/types/benutzer/BenutzerKompetenz";
import { ServerMode } from "@core/core/types/ServerMode";
import type { KindergaertenListeManager } from "@ui/ui/manager/kataloge/KindergaertenListeManager";

import type { RouteApp } from "~/router/apps/RouteApp";
import { RouteDataKindergaerten } from "~/router/apps/schule/kataloge/kindergaerten/RouteDataKindergaerten";
import { routeKindergaertenDaten } from "~/router/apps/schule/kataloge/kindergaerten/RouteKindergaertenDaten";
import { routeKindergaertenGruppenprozesse } from "~/router/apps/schule/kataloge/kindergaerten/RouteKindergaertenGruppenprozesse";
import { routeKindergaertenNeu } from "~/router/apps/schule/kataloge/kindergaerten/RouteKindergaertenNeu";
import { RouteSchuleMenuGroup } from "~/router/apps/schule/RouteSchuleMenuGroup";
import { RouteAuswahlNode } from "~/router/RouteAuswahlNode";
import type { RouteNode } from "~/router/RouteNode";


const KindergartenApp = () => import("~/components/schule/kataloge/kindergaerten/KindergaertenApp.vue");
const KindergaertenAuswahl = () => import("~/components/schule/kataloge/kindergaerten/KindergaertenAuswahl.vue");

export class RouteKindergaerten extends RouteAuswahlNode<KindergaertenListeManager, RouteDataKindergaerten, RouteApp> {

	public constructor() {
		super([Schulform.G, Schulform.PS, Schulform.S, Schulform.V, Schulform.FW, Schulform.WF],
			[BenutzerKompetenz.KATALOG_EINTRAEGE_ANSEHEN, BenutzerKompetenz.KATALOG_EINTRAEGE_AENDERN], "schule.kindergaerten",
			String.raw`schule/kindergaerten/:id(\d+)?`, KindergartenApp, KindergaertenAuswahl, new RouteDataKindergaerten());
		super.mode = ServerMode.STABLE;
		super.text = "Kindergärten";
		super.menugroup = RouteSchuleMenuGroup.KATALOGE;
		super.children = [
			routeKindergaertenDaten,
			routeKindergaertenNeu,
			routeKindergaertenGruppenprozesse,
		];
		super.defaultChild = routeKindergaertenDaten;
		super.updateIfTarget = this.doUpdateIfTarget;
	}

	protected doUpdateIfTarget = async (to: RouteNode<any, any>, to_params: RouteParams, from: RouteNode<any, any> | undefined) => {
		if (!this.data.manager.hasDaten()) {
			return;
		}
		return this.getRouteSelectedChild();
	};
}

export const routeKindergaerten = new RouteKindergaerten();
